import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { List as List$1 } from '@mui/material';
var _excluded = ["children", "subheader", "dense", "disablePadding", "className", "sx"];
var List = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      subheader = _ref.subheader,
      dense = _ref.dense,
      disablePadding = _ref.disablePadding,
      className = _ref.className,
      sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(List$1, _extends({
    subheader: subheader,
    dense: dense,
    disablePadding: disablePadding,
    className: className,
    sx: sx,
    ref: ref
  }, rest), children);
});
List.displayName = 'List';
export { List };